<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<div class="content">
  <app-header-card [title]="'Qualification Round'" class="header">
    <div class="header-container">
      <div class="buttons-container">
        <button mat-raised-button color="primary" [routerLink]="'..'">Back to Overview</button>
        <button mat-flat-button color="primary" (click)="openCopyPublicLinkDialog()">
          Public live page
          <mat-icon>share</mat-icon>
        </button>
        <div [matTooltip]="getStartKoPhaseButtonTooltip()">
          <button
            mat-flat-button
            [disabled]="!qualificationMatchesFinished() || koPhaseStarted()"
            (click)="startKoPhase()"
            color="primary"
          >
            Start KO
          </button>
        </div>
      </div>
    </div>
  </app-header-card>
  <div class="matches mat-elevation-z8">
    <app-qualification-matches
      [qualificationMatches]="qualificationMatches()"
      [tournamentId]="tournamentId()"
      [teamDtos]="teamDtos()"
      [disableMatchEdit]="koPhaseStarted()"
      (generateQualificationMatches)="generateQualificationMatches()"
      (onMatchUpdate)="onMatchUpdate($event)"
      (markTeamDrinksPickedUp)="markTeamDrinksPickedUp($event)"
    ></app-qualification-matches>
  </div>
  <div class="score-table mat-elevation-z8">
    <app-tournament-score-table
      (checkInTeam)="checkInTeam($event)"
      [scoreDtos]="scoreDtos()"
      [teams]="teamDtos()"
    ></app-tournament-score-table>
  </div>
</div>
